import React from "react"

const Icon = ({ name, className, onClick, onKeyPress, ariaLabel, isSelectable }) => {
  return (
    <i
      className={`icon icon-${name} ${className}`}
      tabIndex={isSelectable ? 0 : -1}
      onClick={onClick}
      onKeyPress={onKeyPress}
      aria-label={ariaLabel}
    />
  )
}

Icon.defaultProps = {
  onClick: () => {},
  onKeyPress: () => {},
  isSelectable: true,
}

export default Icon
